import { useTranslation } from 'react-i18next';
import { useApp } from '@/context/AppContext';

export default function AddInvoiceModal({ data }) {
  const { t } = useTranslation(['painterops', 'common']);
  const { customers, addInvoice, closeModal, cloudMode } = useApp();
  const defaultDue = new Date(Date.now() + 14 * 86400000).toISOString().slice(0, 10);
  // Hide optimistic customers whose cloud insert is still pending — their
  // temp id (Date.now()) would FK-violate against customers.id.
  const selectable = cloudMode
    ? customers.filter(c => !(typeof c.id === 'number' && c.id > 1e10))
    : customers;

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const d = Object.fromEntries(fd);
    addInvoice({
      custId:  Number(d.custId),
      amount:  Number(d.amount),
      service: d.service,
      due:     d.due,
    });
    closeModal();
  };

  return (
    <div className="modal">
      <div className="modal-head">
        <span className="modal-title">{t('addInvoice.title')}</span>
        <button className="btn btn-ghost btn-sm" onClick={closeModal}>✕</button>
      </div>
      <div className="modal-body">
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label>{t('addInvoice.customerLabel')}</label>
            <select name="custId" required defaultValue={data?.custId || ''}>
              <option value="">{t('addInvoice.customerPlaceholder')}</option>
              {selectable.map(c => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </select>
          </div>
          <div className="form-row">
            <div className="field">
              <label>{t('addInvoice.serviceLabel')}</label>
              <input name="service" placeholder={t('addInvoice.servicePlaceholder')} required />
            </div>
            <div className="field">
              <label>{t('addInvoice.amountLabel')}</label>
              <input name="amount" type="number" min="1" placeholder={t('addInvoice.amountPlaceholder')} required />
            </div>
          </div>
          <div className="field">
            <label>{t('addInvoice.dueLabel')}</label>
            <input name="due" type="date" defaultValue={defaultDue} />
          </div>
          <div className="modal-foot">
            <button type="button" className="btn btn-ghost" onClick={closeModal}>{t('common:actions.cancel')}</button>
            <button type="submit" className="btn btn-primary">{t('addInvoice.submit')}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
